import type { FieldValidation } from "svelte-forms2";

type Validator = (value: any) => FieldValidation | Promise<FieldValidation>;

export const hasOnlyLowercaseAlphanumeric = () => {
  return (password: string) => {
    return {
      valid: /^[a-z0-9]{20}$/.test(password),
      name: "contains_non_lowercase_alphanumeric",
    };
  };
};
